import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { TooltipRoot } from './Tooltip.style';

const Tooltip = forwardRef(
  (
    { variant = 'default', maxWidth = 400, arrow: incomingArrow, ...rest },
    ref
  ) => {
    const arrow = variant === 'info' || incomingArrow;
    return (
      <TooltipRoot
        ref={ref}
        variant={variant}
        arrow={arrow}
        maxWidth={maxWidth}
        {...rest}
      />
    );
  }
);

Tooltip.displayName = 'Tooltip';
Tooltip.muiName = 'Tooltip';

Tooltip.propTypes = {
  variant: PropTypes.oneOf(['default', 'info']),
  /**
   * MUI's default spacing (margin) are deeply nested so we've created a simple API to allow overriding spacing with ease.
   */
  spacing: PropTypes.string,
  /**
   * Customize the maxWidth of the tooltip - only enabled for info variant
   */
  maxWidth: PropTypes.number
};

export default Tooltip;
